// Sunday morning stubs — slower brunch energy than the weekday
// rush. Fires Sunday 6-12. Several overlap with the brunch bucket
// but lean toward the longer-form things you only make on a slow
// morning.

export const SUNDAY_MORNING_STUBS = [
  {
    id: "shakshuka",
    title: "Shakshuka",
    emoji: "🍳",
    blurb: "Eggs poached in spiced tomato sauce",
    discoveryTags: ["sunday-morning", "brunch", "easter"],
    cuisine: "mediterranean",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 30,
    keyIngredients: ["eggs", "tomatoes", "bell_pepper", "onion", "feta", "cumin"],
    buildHint: "build sauce in cast iron — sauté pepper + onion, bloom cumin + paprika, simmer crushed tomato 10 min, crack eggs into wells, cover until whites just set",
    producesCanonical: null,
  },
  {
    id: "breakfast-strata",
    title: "Breakfast Strata",
    emoji: "🍳",
    blurb: "Savory bread pudding with eggs and cheese",
    discoveryTags: ["sunday-morning", "brunch", "easter", "christmas", "make-ahead"],
    cuisine: "american",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 75,
    keyIngredients: ["bread", "eggs", "milk", "cheddar", "ham"],
    buildHint: "stale bread cubes layer with cheese + ham, custard of eggs + milk + mustard poured over, rest 30 min (or overnight) for absorption, bake 350F until set + golden",
    producesCanonical: null,
  },
  {
    id: "cinnamon-rolls",
    title: "Cinnamon Rolls",
    emoji: "🥐",
    blurb: "Yeasted dough, gooey middle, cream cheese frosting",
    discoveryTags: ["sunday-morning", "brunch", "christmas", "kids"],
    cuisine: "american",
    course: "dessert",
    mealTiming: "breakfast",
    difficulty: "medium",
    estimatedTime: 180,
    keyIngredients: ["flour", "yeast", "butter", "brown_sugar", "cinnamon", "cream_cheese"],
    buildHint: "enriched dough first rise 90 min, roll thin rectangle, slather butter + cinnamon sugar, roll tight + slice, second rise 45 min, bake 350F, frost warm",
    producesCanonical: null,
  },
  {
    id: "biscuits-and-gravy",
    title: "Biscuits and Sausage Gravy",
    emoji: "🍞",
    blurb: "Flaky biscuits drowned in peppery white gravy",
    discoveryTags: ["sunday-morning", "brunch", "comfort-food", "cold-weather"],
    cuisine: "american",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 45,
    keyIngredients: ["flour", "butter", "buttermilk", "sausage", "milk"],
    buildHint: "cold butter in flour for flaky layers — fold dough 3 times like puff pastry, gravy is sausage + roux made in fond + milk + lots of black pepper",
    producesCanonical: null,
  },
];
